export const FAQ_HOME = "FAQ_HOME";
export const FAQ_HOME_LOADING = "FAQ_HOME_LOADING";
export const FAQ = "FAQ";
export const FAQ_LOADING = "FAQ_LOADING";
